import { Component, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { IonicPage, NavController, Events, AlertController, ModalController, PopoverController, TextInput, Content } from 'ionic-angular';
import { TranslateService, TranslationChangeEvent } from '@ngx-translate/core';

//Providers
import { SBSuiteManager } from '../../modules/sbsuite/providers/sbsuite.manager';

//Decorators
import  { RedirectOnUserAttr } from '../../decorators/redirect-on-user-attr.decorator';
import { SBSuiteEvents } from '../../modules/sbsuite/models/sbsuite.events';

import {InternalsModal} from './internals.modal';


/**
 * Página para las fichadas automáticas.
 *
 * @export
 * @class AutoClocking
 * @implements {OnDestroy}
 * @implements {OnInit}
 */
@RedirectOnUserAttr()
@IonicPage({
  name: 'AutoClocking',
  segment: 'fichada-auto'
})
@Component({
  selector: 'page-auto-clocking',
  templateUrl: 'auto-clocking.html'
})
export class AutoClocking implements AfterViewInit, OnDestroy {

  @ViewChild(Content) content: Content;

  /**
   * TextInput de operario.
   *
   * @type {TextInput}
   * @memberof AutoClocking
   */
  @ViewChild('operatorInput') operatorInput: TextInput;


  /**
   * TextInput de OF.
   *
   * @type {TextInput}
   * @memberof AutoClocking
   */
  @ViewChild('moInput') moInput: TextInput;

  /**
   * Contiene el nombre del tab actual: 'auto';
   *
   * @type {string}
   * @memberof AutoClocking
   */
  currentTab: string = 'auto';

  /**
   * Contiene las traducciones necesarias para el componente.
   *
   * @type {*}
   * @memberof AutoClocking
   */
  texts: any = null;

  /**
   * Flag de seleccion de operador.
   *
   * @type {boolean}
   * @memberof AutoClocking
   */
  focusedOperator: boolean = false;

  /**
   * Guarda el valor de input de operador al realizar el focus.
   *
   * @type {string}
   * @memberof AutoClocking
   */
  focusOperatorValue: string = '';

  /**
   * Flag de seleccion de OF.
   *
   * @type {boolean}
   * @memberof AutoClocking
   */
  focusedMO: boolean = false;

  /**
   * Mascara de OF.
   *
   * @type {string}
   * @memberof AutoClocking
   */
  maskMO: string = new Date().getFullYear().toString().substr(-2) + '0000';


  /**
   * Eliminar?
   * 
   * @TODO: Eliminar?
   *
   * @type {string}
   * @memberof AutoClocking
   */
  input: string = '';


  /**
   * Eliminar?
   * 
   * @TODO: Eliminar?
   *
   * @type {boolean}
   * @memberof AutoClocking
   */
  assistant: boolean = true;


  /**
   * Eliminar?
   * 
   * @TODO: Eliminar?
   *
   * @type {*}
   * @memberof AutoClocking
   */
  numericKeyboard: any = [
    ['1', '2', '3', 'Backspace:2'],
    ['4', '5', '6', 'Spacer:2'],
    ['7', '8', '9', 'Spacer:2'],
    ['Spacer', '0', 'Spacer:3'],
  ];
  

  /**
   * Crea una instancia de la página AutoClocking.
   * 
   * @param {NavController} navCtrl Controlador de navegación.
   * @param {ModalController} modalCtrl Controlador de navegación.
   * @param {AlertController} alertCtrl Controlador de alertas.
   * @param {PopoverController} popoverCtrl Controlador de popover.
   * @param {SBSuiteManager} sbSuiteManager Gestor de sbSuite.
   * @param {TranslateService} translateService Servicio de traducciones.
   * @memberof AutoClocking
   */
  constructor(
    public navCtrl: NavController, 
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public popoverCtrl: PopoverController,
    public sbSuiteManager: SBSuiteManager,
    public translateService: TranslateService,
    public events: Events
    
  ) {
    this.getTranslate();
    this.translateService.onLangChange.subscribe((event: TranslationChangeEvent) => { //Escucha los cambios de lenguaje
      this.getTranslate();
    });

  }

  ngOnDestroy(){
    this.events.unsubscribe(SBSuiteEvents.EVENTS.OF_FOCUS);
  }

  ngAfterViewInit(){
    this.events.subscribe(SBSuiteEvents.EVENTS.OF_FOCUS,(data,time)=>{
      let yOffset = this.moInput.getNativeElement().offsetTop;
      this.content.scrollTo(0, yOffset, 300);
      setTimeout(()=>this.moInput.setFocus(),300);
    });
  }

  /**
   * Inicia las traducciones del componente.
   *
   * @memberof AutoClocking
   */
  getTranslate(): void{
    this.translateService.get([
      'OPERATOR_PLANNING', 
      'OPERATOR_PLANNING_CONTENT',
      'PRODUCT_INFO',
      'PRODUCT_INFO_CONTENT',
      'OPERATOR_CODE',
      'OPERATOR_CODE_CONTENT',
      'MO_CODE',
      'MO_CODE_CONTENT',
      'OPERATOR',
      'MANUFACTURING_ORDER',
      'OPERATION',
      'CANCEL',
      'APPLY',
      'MATERIAL_INFO',
      'MATERIAL_INFO_CONTENT',
      'LOCK_ITEMS',
      'INSERT_%',
      'INSERT_MO'

    ]).subscribe(res => {
      this.texts = res;
    });
  }


  /**
   * Canvia el tab actual manual.
   *
   * @memberof AutoClocking
   */
  tabChoose(): void{
    this.navCtrl.setRoot('ManuallyClocking');
  }


  /**
   * Llama a la función de salir operario.
   * 
   * Detiene el cronómetro de fichada.
   *
   * @memberof AutoClocking
   */
  endClockIn() : void{
    this.assistant = true;
    this.sbSuiteManager.salirOperario();
    this.sbSuiteManager.sbSuite.endCurrent();
    this.sbSuiteManager.stopChronometer();
  }


  
  /**
   * Devuelve True si el operador no está asignado.
   *
   * @returns {boolean} True si no hay operario.
   * @memberof AutoClocking
   */
  hiddenIfNoOperator(): boolean{
    return this.sbSuiteManager.sbSuite.currentOperator == '';
  }


  /**
   * Devuelve True si no hay operador ni OF assignados.
   *
   * @returns {boolean} True si no hay operador y OF.
   * @memberof AutoClocking
   */
  hiddenIfNoOperatorAndMO(): boolean{
    let op = this.sbSuiteManager.sbSuite.clocking.current.operator == '';
    let mo = this.sbSuiteManager.sbSuite.clocking.current.manufacturingOrder == '';
    return op || mo;
  }

  
  /**
   * Devuelve True si el botón de materiales está deshabilitado.
   *
   * @returns {boolean} True si no hay OF seleccionada.
   * @memberof AutoClocking
   */
  disableMaterials(): boolean{
    return this.sbSuiteManager.sbSuite.clocking.current.manufacturingOrder == '';
  }


  /**
   * Devuelve True si el botón de "play" está deshabilitado.
   *
   * @returns {boolean} True si no hay ni  OF seleccionada ni operario ni operación.
   * @memberof AutoClocking
   */
  disableStart(): boolean{
    let isSetOp = this.sbSuiteManager.sbSuite.clocking.current.operator == '';
    isSetOp = true;
    let isSetMO = this.sbSuiteManager.sbSuite.clocking.current.manufacturingOrder != '' || this.sbSuiteManager.sbSuite.clocking.last.manufacturingOrder != '';
    let isSetOpt = this.sbSuiteManager.sbSuite.getCurrentOperationName() != '' || this.sbSuiteManager.sbSuite.getLastOperationName() != '';

    return !(isSetOp && isSetMO && isSetOpt);
  }

  /**
   * Devuelve si Operario, OF o Operación está bloqueado.
   *
   * @param {string} [item='operator'] Control deshabilitado: 'operario', 'manufacturingOrder' o 'operation'.
   * @returns {boolean} True si está bloqueado.
   * @memberof AutoClocking
   */
  isLock(item: string = 'operator'): boolean{
    if(item == 'operator') return this.sbSuiteManager.sbSuite.controls.operatorLock;
    if(item == 'manufacturingOrder') return this.sbSuiteManager.sbSuite.controls.manufacturingOrderLock;
    if(item == 'operation') return this.sbSuiteManager.sbSuite.controls.operationLock;
    return false;
  }

  
  /**
   * Cambia el operario actual.
   *
   * @param {string} value El código del operario.
   * @returns {void}
   * @memberof AutoClocking
   */
  setOperator(value: string) : void{
    if(!value) return;
    this.sbSuiteManager.cambiarOperario(value);
  }

  /**
   * Establece la OF.
   *
   * @param {string} value Código de la OF.
   * @memberof AutoClocking
   */
  setManufacturingOrder(value: string) : void{
    this.sbSuiteManager.sbSuite.clocking.current.manufacturingOrder = value;
  }


  /**
   * Gestiona el click del FAB button en función del estado de la fichada actual.
   *
   * @returns {void}
   * @memberof AutoClocking
   */
  clickFabButton(): void{
    let state = this.getFabIcon();
    if(state == 'log-in'){
      console.warn('Deprecated action');
    }
    else if(state == 'list-box'){
      console.warn('Deprecated action');
    }
    else if(state == 'construct'){
      this.sbSuiteManager.getOpsProdOfDropdown(this.sbSuiteManager.sbSuite.currentProducts[0].code, 'auto');
    }
    else if(state == 'play'){
      this.sbSuiteManager.continueLastClockIn();
    }
    else if(state == 'log-out'){
      this.endClockIn();
    }
  }


  /**
   * Deshabilita el FAB button de la página.
   *
   * @returns
   * @memberof AutoClocking
   */
  disableFabButton(){
    let state = this.getFabIcon();
    if(state == 'log-in') return this.sbSuiteManager.sbSuite.controls.operatorLock;
    else if(state == 'list-box') return this.sbSuiteManager.sbSuite.controls.manufacturingOrderLock;
    else if(state == 'construct') return this.sbSuiteManager.sbSuite.controls.operationLock;
    else if(state == 'play') return false;
    else if(state == 'log-out') return this.sbSuiteManager.sbSuite.controls.operatorLock;
  }

  /**
   * Devuelve el nombre del icono del FAB button
   * en función del estado de la fichada actual.
   *
   * @returns {string} El nombre del icono a mostrar.
   * @memberof AutoClocking
   */
  getFabIcon(): string{
    if(this.focusedOperator || this.focusedMO) return 'arrow-round-forward';
    if(!this.sbSuiteManager.sbSuite.clocking.current.operator) return 'log-in';
    else if(this.disableStart()){
       if(!this.sbSuiteManager.sbSuite.clocking.current.manufacturingOrder) return 'list-box';
       if(this.sbSuiteManager.sbSuite.currentProducts.length<1) return 'list-box';
       if(!this.sbSuiteManager.sbSuite.getCurrentOperationName()) return 'construct';
    } 
    else if(!this.sbSuiteManager.sbSuite.clocking.current.start) return 'play';
    else return 'log-out';
  }


  /**
   * Abre el aviso de funcionalidad futura.
   * 
   * @TODO: Implementar en otra fase.
   *
   * @memberof AutoClocking
   */
  showCalendar(){
    this.functionAlert(this.texts.OPERATOR_PLANNING, this.texts.OPERATOR_PLANNING_CONTENT);
  }

  /**
   * Abre el aviso de funcionalidad futura.
   * 
   * @TODO: Implementar en otra fase.
   *
   * @memberof AutoClocking
   */
  showProductInfo(){
    this.functionAlert(this.texts.PRODUCT_INFO, this.texts.PRODUCT_INFO_CONTENT);
  }

  /**
   * Cambia de OF con la última fichada.
   *
   * @memberof AutoClocking
   */
  continueLast(){
    this.sbSuiteManager.cambiarOf(this.sbSuiteManager.sbSuite.getLast().operation.code,this.sbSuiteManager.sbSuite.currentOperator);
  }

  /**
   * Abre el aviso de funcionalidad futura.
   * 
   * @TODO: Implementar en otra fase.
   *
   * @memberof AutoClocking
   */
  showMaterials(){
    this.functionAlert(this.texts.MATERIAL_INFO, this.texts.MATERIAL_INFO_CONTENT);
  }

  /**
   * Funcion de trackBy de la lista interna de OFs
   *
   * @param {*} index
   * @param {*} item
   * @returns
   * @memberof AutoClocking
   */
  trackByInternalList(index, item) {
    return index;
  }


  /**
   * Selecciona para fichar un elemento de la lista interna de OFs
   *
   * @param {number} [index=0]
   * @memberof AutoClocking
   */
  internalSelected(index: number = 0){
    this.sbSuiteManager.sbSuite.setInternalAsCurrent(index);
    this.sbSuiteManager.cambiarOf(this.sbSuiteManager.sbSuite.currentOperation.code, this.sbSuiteManager.sbSuite.getCurrentOperator());
  }

  /**
   * Realiza el focus del input de operador.
   *
   * @memberof AutoClocking
   */
  focusingOperator(){
    this.operatorInput.setFocus();
  }

  /**
   * Evento al realizar focus al input de operador.
   *
   * @memberof AutoClocking
   */
  focusOperator(){
    this.focusOperatorValue = this.operatorInput.value;
    this.focusedOperator = true;
  }

  /**
   * Evento al perder el focus del input del operador.
   *
   * @memberof AutoClocking
   */
  blurOperator(){
    this.focusedOperator = false;
    if(this.focusOperatorValue != this.operatorInput.value) this.sbSuiteManager.cambiarOperario(this.sbSuiteManager.sbSuite.currentOperator);
  }

  /**
   * Realiza el focus del input de OF.
   *
   * @memberof AutoClocking
   */
  focusingMO(){
    this.moInput.setFocus();
    this.moInput.value = this.maskMO;
  }

  /**
   * Evento al realizar focus al input de OF.
   *
   * @memberof AutoClocking
   */
  focusMO(){
    this.sbSuiteManager.sbSuite.currentOF = this.maskMO;
    this.focusedMO = true;
  }

  /**
   * Evento al perder el focus del input de OF.
   *
   * @returns
   * @memberof AutoClocking
   */
  blurMO(){
    this.focusedMO = false;
    let value = this.sbSuiteManager.sbSuite.currentOF;
    if(value.length<3) return;
    let prefix = this.maskMO.substr(0,2);
    let val = value.substr(2, value.length - 1);
    let dif = this.maskMO.length - (prefix.length + val.length);
    value = prefix;
    for(let i=0; i<dif; i++){
      value += '0';
    }
    value+= val;
    this.sbSuiteManager.sbSuite.currentOF = value;
    if(value == this.maskMO){
      this.sbSuiteManager.sbSuite.restoreCurrentIfStarted();
      return;
    }
    if(this.sbSuiteManager.sbSuite.currentOF) this.sbSuiteManager.getProductosOfDropdown(this.sbSuiteManager.sbSuite.currentOF)
  }

  postBlurOperator(){
    //this.moInput.setFocus();
  }

  postBlurMO(){
    //if(this.sbSuiteManager.sbSuite.currentOF) this.sbSuiteManager.getProductosOfDropdown(this.sbSuiteManager.sbSuite.currentOF)
  }

  /**
   * Evento al realizar un cambio al input de operador para pantallas pequeñas.
   *
   * @param {*} event
   * @memberof AutoClocking
   */
  changeMO(event: any){
    let exculdeKeys = ['Enter'];
    let key = event.key;
    if(exculdeKeys.indexOf(key)==-1){
      event.preventDefault();
      event.stopPropagation();
      let prefix = this.maskMO.substr(0,2);
      let val = this.sbSuiteManager.sbSuite.currentOF.substr(3, this.maskMO.length);
      let value =  this.sbSuiteManager.sbSuite.currentOF;
      if(value.length >= this.maskMO.length) value = `${prefix}${val}${key}`;
      else value = `${value}${key}`;
      this.sbSuiteManager.sbSuite.currentOF = value;
    } 
  }


  //////// UI Functions /////////


  /**
   * Abre un alert para funcionalidades en desarrollo.
   * 
   * @TODO: Eliminar una vez implementadas las funcionalidades.
   *
   * @param {string} [title='']
   * @param {string} [message='']
   * @memberof AutoClocking
   */
  functionAlert(title: string = '', message: string = ''): void{
    let alert = this.alertCtrl.create({
      title: title,
      message: message,
      buttons: ['OK']
    });
    alert.present();
  }


  /**
   * Abre el alert para bloquear controles.
   *
   * @memberof AutoClocking
   */
  presentLock(): void{
    let alert = this.alertCtrl.create();
    alert.setTitle(this.texts.LOCK_ITEMS);

   alert.addInput({
      type: 'checkbox',
      label: this.texts.OPERATOR,
      value: 'operator',
      checked: this.sbSuiteManager.sbSuite.controls.operatorLock
    });

    alert.addInput({
      type: 'checkbox',
      label: this.texts.MANUFACTURING_ORDER,
      value: 'manufacturingOrder',
      checked: this.sbSuiteManager.sbSuite.controls.manufacturingOrderLock
    });
    alert.addInput({
      type: 'checkbox',
      label: this.texts.OPERATION,
      value: 'operation',
      checked: this.sbSuiteManager.sbSuite.controls.operationLock
    });


    alert.addButton(this.texts.CANCEL);
     alert.addButton({
      text: this.texts.APPLY,
      handler: data => {
        this.sbSuiteManager.sbSuite.controls.operatorLock = data.indexOf('operator')==-1?false:true;
        this.sbSuiteManager.sbSuite.controls.manufacturingOrderLock = data.indexOf('manufacturingOrder')==-1?false:true;
        this.sbSuiteManager.sbSuite.controls.operationLock = data.indexOf('operation')==-1?false:true;
      }
    });
    alert.present();
  }

  /**
   * Abre el modal para la selección de una OF interna.
   *
   * @memberof MyApp
   */
  openInternals(): void{
    let internalsModal = this.modalCtrl.create(InternalsModal);
    internalsModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/auto-clocking/auto-clocking.ts